import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { UserHttpService } from '../services/user.http.service';

export const authGuard: CanActivateFn = (_route, state) => {
    const router = inject(Router);
    const httpService = inject(UserHttpService);

    const isAdmin = (user: any) => ['admin', 'super_admin'].includes(String(user?.role ?? '').toLowerCase());
    const isVerified = (user: any) => {
        const verified = user?.verified;
        return verified === true || verified === 'true' || verified === 1 || verified === '1';
    };
    const isVerifyRoute = state.url.startsWith('/verify');
    const currentUser = httpService.currentUser();

    if (currentUser && isAdmin(currentUser)) {
        if (isVerifyRoute && isVerified(currentUser)) {
            return router.createUrlTree(['/dashboard']);
        }
        return true;
    }

    if (currentUser) {
        httpService.logout();
        return router.createUrlTree(['/login']);
    }

    return httpService.getCurrentUser().pipe(
        map((user) => {
            if (isAdmin(user)) {
                if (isVerifyRoute && isVerified(user)) {
                    return router.createUrlTree(['/dashboard']);
                }
                return true;
            }
            httpService.logout();
            return router.createUrlTree(['/login']);
        }),
        catchError(() => {
            httpService.setCurrentUser(null);
            return of(router.createUrlTree(['/login']));
        }),
    );
};



// token version
// import { inject } from '@angular/core';
// import { CanActivateFn, Router } from '@angular/router';
// import { UserHttpService } from '../services/user.http.service';

// export const authGuard: CanActivateFn = () => {
//     const router = inject(Router);
//     const httpService = inject(UserHttpService);
//     const token = httpService.getToken();

//     if (!token) {
//         httpService.logout();
//         router.navigate(['/login']);
//         return false;
//     }

//     return true;
// };
